<template>
	<div class="w-100">
		<input
			type="text"
			class="form-control"
			:id="id"
			:value="value"
			placeholder="e.g. front_v2"
			autocomplete="off"
			spellcheck="false"
			@input="$emit('input', $event.target.value)"
			@blur="normalize"
		/>
		<small class="form-text text-muted">
			Optional. Added to short-link redirects as <code>&amp;utm_content=</code>; QR scans get <code>_qr</code> appended
			(e.g. <code>front_v2_qr</code>, or just <code>qr</code> when empty).
		</small>
	</div>
</template>

<script>
import { normalizeUtmCampaign } from '@/utils/utm'

// Same format as utm_campaign (lowercase, underscores); the API normalizes it too.
export default {
	name: 'UtmContentInput',
	props: {
		value: { type: String, default: '' },
		id: { type: String, default: null },
	},
	methods: {
		normalize() {
			const normalized = normalizeUtmCampaign(this.value) || ''
			if (normalized !== (this.value || '')) this.$emit('input', normalized)
		},
	},
}
</script>
